import Swal from 'sweetalert2';

import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { User } from './../../../_models/user';
import { AuthService } from './../../../_services/auth.service';
import { UserService } from './../../../_services/user.service';


@Component({
  selector: 'app-register-step-two-password',
  templateUrl: './register-step-two-password.component.html',
  styleUrls: ['./register-step-two-password.component.css']
})
export class RegisterStepTwoPasswordComponent implements OnInit {
  form: FormGroup;
  loading = false;
  submitted = false;
  responseMessage = '';
  resultInfo = { resultCode: "", userMessage: "" }
  errorEncountered = false
  resultCode = ""
  isRegistrationSuccess = false
  roles: string[] = [];
  user: User = new User()
  registeredUser = new User()


  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private userService: UserService

  ) {
    this.authService.gatePass.subscribe(
      value => {
        if (value.is_logged_in) {
          this.router.navigate(['/']);
        }
      }
    )
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      password: ['', Validators.compose([Validators.required, Validators.minLength(5)])],
      passwordConfirmation: ['', Validators.compose([Validators.required, Validators.minLength(5)])]
    });

    this.userService.registrationData
      .subscribe(value => {
        this.registeredUser = value;
      });

  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onSubmit(): void {
    this.submitted = true;
    if (!this.checkPasswords()) {
      Swal.fire('Oops', "Passwords do no match", 'info')
      return
    }
    if (!this.checkObviousPasswords) {
      Swal.fire('Oops', "The password cannot be the same as email", 'info')
      return
    }
    this.user.id = 0

    this.user.username = this.registeredUser.username
    this.user.password = this.form.value.password
    this.user.passwordConfirmation = this.form.value.passwordConfirmation


    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    this.loading = true;
    this.errorEncountered = false
    this.userService.register(this.user).subscribe(
       {
        next:(data:ResultData) => {
        this.registeredUser = data.rs.data['userData']
        this.userService.registrationData.next(this.registeredUser)
        console.log("user data", this.registeredUser)


        this.resultInfo = data.rs.data['resultInfo']

        let status = data.rs.data['server_user_id'] != 0
        let msg = this.resultInfo.userMessage
        this.loading = false
        if (status) {

          let resultCode = this.resultInfo.resultCode


          this.userService.userMessage.next(msg)
          if (resultCode == "USER_EXISTS_AND_ENABLED") {
            this.router.navigate(['/user/new/step/verification/success'])
          } else if (resultCode == "USER_EXISTS_AND_NOT_ENABLED") {
            this.router.navigate(['/user/new/step/verification'])
          } else {
            this.router.navigate(['/user/new/step/verification'])
          }
          this.isRegistrationSuccess = true
        } else {
          this.isRegistrationSuccess = false
          this.responseMessage = data.rs.data['message']
          this.errorEncountered = true
          Swal.fire('Oops', msg, 'info')
          this.router.navigate(['user/new/step/one'])
        }

      },
        error: (err) => {
          this.loading = false
          this.responseMessage = err.error.message;
          this.isRegistrationSuccess = false
          this.errorEncountered = true
          Swal.fire('Oops', err.error.message, 'info')
        }
    }
    )
  }



  reloadPage(): void {
    window.location.reload();
  }
  checkPasswords() {
    let isOk = true
    if (this.f.password.touched || this.f.passwordConfirmation.touched) {
      isOk = this.f.password.value == this.f.passwordConfirmation.value
    }
    return isOk
  }

  checkObviousPasswords() {
    return this.form.value.password == this.form.value.username
  }
}
